import SidebarMenu from './SidebarMenu.js';

export default SidebarMenu;
